import { UI } from './ui';
import { Render } from './render';

document.addEventListener("DOMContentLoaded", () => { 
    UI.init();
    UI.nav.bind();
    UI.tabs.bind();
    UI.modal.bind();
    UI.player.bind();     
    UI.gallery.init();   
} );

window.addEventListener('resize', () => { UI.init() } );

/** 
 * Render React microfrontends components
 */
Render.posts('.products-list', wp_core.rest.products, 'product');
Render.team('#team', wp_core.rest.team);
//Render.faq('.faq-categories', wp_core.rest.faq_categories);